import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const Wrapper = styled.div`
  position: relative;
  background: linear-gradient(180deg, #d77e5d 9.48%, #3f62ae 100%);
`;

export const ImageWrapper = styled.div`
  padding: 0 12vw ${calculateResponsiveSize(120)};
  ${mediaMax("tabletLandscape")} {
    padding: 0 20px 20px;
  }
`;
